import React, {useState, useEffect} from 'react';
import styles from './PartyResults.module.css';

const PartyResults = ({ title = "Party Wise" }) => {
  const [partyData, setPartyData] = useState([])
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const timestamp = `${hours}${minutes}`;
        const response = await fetch(`/result/ACF2021/json/element359.json?ver=${timestamp}`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch party results');
        }

        const data = await response.json();
        // Transform the data to match the expected format
        const formattedData = data.items.map(item => ({
          party: item.Party,
          lead: item.Lead_2025,
          year2020: item.Lead_2020,
          alliance: item.Alliance
        }));

        setPartyData(formattedData);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Failed to load party data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  /*  const partyData = [
      { party: 'BJP', lead: 10, year2020: 10 },
      { party: 'JDU', lead: 10, year2020: 20 },
      { party: 'RJD', lead: 8, year2020: 15 },
      { party: 'INC', lead: 6, year2020: 12 },
      { party: 'LJP', lead: 4, year2020: 8 }
    ];*/

  const filteredPartyData = (() => {
    return partyData.filter(party => party.alliance.toLowerCase() === title.toLowerCase());
  })();

  if (loading) return <div>Loading {title.toLowerCase()} results...</div>;
  if (error) return <div className={styles.error}>{error}</div>;
  if (!filteredPartyData?.length) return null;

  return (
    <div className={styles.partyResults}>
      {title !== 'OTH' && (
        <h3 style={{ color: `var(--${title.toLowerCase()}-color)` }}>{title}</h3>
      )}
      <div className={styles.resultsTableDiv} style={{ borderColor: `var(--${title.toLowerCase()}-color)` }}>
        <table id={`${title.toLowerCase()}-parties`} className={styles.resultsTable}>
          {title !== 'OTH' && (
            <thead>
            <tr>
              <th style={{ borderColor: `var(--${title.toLowerCase()}-color)` }}>Party</th>
              <th style={{ borderColor: `var(--${title.toLowerCase()}-color)` }}>2025</th>
              <th style={{ borderColor: `var(--${title.toLowerCase()}-color)` }}>2020</th>
            </tr>
            </thead>
          )}
          <tbody>
          {filteredPartyData?.map((row, index) => {
            const partyName = row.party
              .toLowerCase()
              .split(/[\s-]/)[0]  // Split on space or hyphen and take first part
              .replace(/[()]/g, ''); // Remove any parentheses

            return (
              <tr key={index}>
                <td>{row.party}</td>
                <td className={styles.leadCell}>
                  {row.lead && row.lead !== 0 && (
                    <div style={{backgroundColor: `var(--${partyName}-color)`}}>
                      {row.lead}
                    </div>
                  )}
                </td>
                <td className={styles.yearCell}>{row.year2020}</td>
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PartyResults;